import FetchWrapper from '../Common/Wrappers/FetchWrapper';
import { Service } from '../Common/service.enum';
import { UserInfo } from '../../..';

export default class UserRepo {
  private fetch: FetchWrapper;

  constructor(fetch: FetchWrapper) {
    this.fetch = fetch;
  }

  getUserInfoV4(): Promise<UserInfo> {
    return this.fetch.getFromService<UserInfo>(Service.GATEWAY, 'v4/permissions');
  }
}
